// store/wishlist/wishlist.selector.js
import { createSelector } from 'reselect';

const selectWishlist = (state) => state.wishlist;

export const selectWishlistItems = createSelector(
  [selectWishlist],
  (wishlist) => wishlist.wishlistItems
);
